import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Company Section */}
        <div className="footer-section">
          <h4>About Us</h4>
          <p>
            The Brik is your solution for keeping essentials secure and organized.
            Perfect for busy individuals who value simplicity and efficiency.
          </p>
        </div>

        {/* Quick Links Section */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/shop">Shop</a></li>
            <li><a href="/metal-wallet">Metal Wallet</a></li>
            <li><a href="/bulk">Bulk & Custom Orders</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/track">Track Your Order</a></li>
            <li><a href="/newsletter">Newsletter</a></li>
            <li><a href="/exchange-and-delivery">Delivery & Exchange Policy</a></li>
            <li><a href="/tnc">Terms and Conditions</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
          </ul>
        </div>

        {/* Gift Guides Section */}
        <div className="footer-section">
          <h4>Gift Guides</h4>
          <ul>
            <li><a href="/gifts-for-men">Gifts for Men</a></li>
            <li><a href="/groomsmen-gifts">Groomsmen Gifts</a></li>
            <li><a href="/gifts-for-college-students">Gifts for College Students</a></li>
            <li><a href="/fathers-day-gifts">Father's Day Gifts</a></li>
            <li><a href="/graduation-gifts">Graduation Gifts</a></li>
          </ul>
        </div>

        {/* Wallet Guides Section */}
        <div className="footer-section">
          <h4>Wallet Guides</h4>
          <ul>
            <li><a href="/wallet-for-college-students">Wallet for College Students</a></li>
            <li><a href="/wallet-for-professionals">Wallet for Professionals</a></li>
            <li><a href="/edc-wallet">EDC Wallet</a></li>
            <li><a href="/brik-vs-ridge">Brik vs Ridge</a></li>
            <li><a href="/wallet-with-built-in-tracker">Wallet with Built-In Tracker</a></li>
            <li><a href="/guides">All Guides</a></li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-section" id="contact-us">
          <h4>Contact Us</h4>
          <p>Email: <a href="mailto:asray@the-brik.com">asray@the-brik.com</a></p>
          <p>Phone: +1 (714) 787-9947</p>
          <p>Address: 119 Stanton Avenue, Ames, IA 50014</p>
        </div>

        {/* Social Media Section */}
        <div className="footer-section" style={{ textAlign: 'center' }}>
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://www.facebook.com/people/The-Brik/61574215883635/"><i className="fab fa-facebook"></i></a>
            <a href="https://www.tiktok.com/@thebrik"><i className="fab fa-tiktok"></i></a>
            <a href="https://www.instagram.com/the.brik/"><i className="fab fa-instagram"></i></a>
            <a href="https://www.linkedin.com/company/103414107"><i className="fab fa-linkedin"></i></a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>© 2025 The Brik. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;